 
export class VejledningAfsnit {
        public overskrift: string;
        public editorStateJson: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/VejledningAfsnit.ts